// Command palette translations for all 11 supported languages

export const commandPaletteTranslations = {
  pt: {
    title: "Paleta de Comandos",
    description: "Pesquisar páginas, transações, clientes, fornecedores, relatórios e ações rápidas",
    placeholder: "Pesquisar ou saltar para...",
    no_results: "Nenhum resultado encontrado",
    navigate: "Navegar",
    navigate_to: "Navegar para",
    quick_actions: "Ações Rápidas",
    quick_action: "Ação rápida",
    transactions: "Transações",
    clients: "Clientes",
    projects: "Projetos",
    vendors: "Fornecedores",
    income: "Receita",
    expense: "Despesa",
    active: "Ativo",
    completed: "Concluído",
    add_new_transaction: "Adicionar Nova Transação",
    create_invoice: "Criar Fatura",
    add_client: "Adicionar Cliente",
    add_project: "Adicionar Projeto",
    add_vendor: "Adicionar Fornecedor",
    navigate_hint: "Navegar",
    select_hint: "Selecionar",
    close_hint: "Fechar"
  },
  en: {
    title: "Command Palette",
    description: "Search for pages, transactions, clients, vendors, reports, and quick actions",
    placeholder: "Search or jump to...",
    no_results: "No results found",
    navigate: "Navigate",
    navigate_to: "Navigate to",
    quick_actions: "Quick Actions",
    quick_action: "Quick action",
    transactions: "Transactions",
    clients: "Clients",
    projects: "Projects",
    vendors: "Vendors",
    income: "Income",
    expense: "Expense",
    active: "Active",
    completed: "Completed",
    add_new_transaction: "Add New Transaction",
    create_invoice: "Create Invoice",
    add_client: "Add Client",
    add_project: "Add Project",
    add_vendor: "Add Vendor",
    navigate_hint: "Navigate",
    select_hint: "Select",
    close_hint: "Close"
  },
  es: {
    title: "Paleta de Comandos",
    description: "Buscar páginas, transacciones, clientes, proveedores, informes y acciones rápidas",
    placeholder: "Buscar o saltar a...",
    no_results: "No se encontraron resultados",
    navigate: "Navegar",
    navigate_to: "Navegar a",
    quick_actions: "Acciones Rápidas",
    quick_action: "Acción rápida",
    transactions: "Transacciones",
    clients: "Clientes",
    projects: "Proyectos",
    vendors: "Proveedores",
    income: "Ingreso",
    expense: "Gasto",
    active: "Activo",
    completed: "Completado",
    add_new_transaction: "Añadir Nueva Transacción",
    create_invoice: "Crear Factura",
    add_client: "Añadir Cliente",
    add_project: "Añadir Proyecto",
    add_vendor: "Añadir Proveedor",
    navigate_hint: "Navegar",
    select_hint: "Seleccionar",
    close_hint: "Cerrar"
  },
  et: {
    title: "Käsupalett",
    description: "Otsi lehti, tehinguid, kliente, tarnijaid, aruandeid ja kiirtoiminguid",
    placeholder: "Otsi või hüppa...",
    no_results: "Tulemusi ei leitud",
    navigate: "Navigeeri",
    navigate_to: "Navigeeri",
    quick_actions: "Kiirtoimingud",
    quick_action: "Kiirtoiming",
    transactions: "Tehingud",
    clients: "Kliendid",
    projects: "Projektid",
    vendors: "Tarnijad",
    income: "Tulu",
    expense: "Kulu",
    active: "Aktiivne",
    completed: "Lõpetatud",
    add_new_transaction: "Lisa Uus Tehing",
    create_invoice: "Loo Arve",
    add_client: "Lisa Klient",
    add_project: "Lisa Projekt",
    add_vendor: "Lisa Tarnija",
    navigate_hint: "Navigeeri",
    select_hint: "Vali",
    close_hint: "Sulge"
  },
  de: {
    title: "Befehlspalette",
    description: "Suche nach Seiten, Transaktionen, Kunden, Lieferanten, Berichten und Schnellaktionen",
    placeholder: "Suchen oder springen zu...",
    no_results: "Keine Ergebnisse gefunden",
    navigate: "Navigieren",
    navigate_to: "Navigieren zu",
    quick_actions: "Schnellaktionen",
    quick_action: "Schnellaktion",
    transactions: "Transaktionen",
    clients: "Kunden",
    projects: "Projekte",
    vendors: "Lieferanten",
    income: "Einnahme",
    expense: "Ausgabe",
    active: "Aktiv",
    completed: "Abgeschlossen",
    add_new_transaction: "Neue Transaktion hinzufügen",
    create_invoice: "Rechnung erstellen",
    add_client: "Kunde hinzufügen",
    add_project: "Projekt hinzufügen",
    add_vendor: "Lieferant hinzufügen",
    navigate_hint: "Navigieren",
    select_hint: "Auswählen",
    close_hint: "Schließen"
  },
  fr: {
    title: "Palette de Commandes",
    description: "Rechercher des pages, transactions, clients, fournisseurs, rapports et actions rapides",
    placeholder: "Rechercher ou accéder à...",
    no_results: "Aucun résultat trouvé",
    navigate: "Naviguer",
    navigate_to: "Naviguer vers",
    quick_actions: "Actions Rapides",
    quick_action: "Action rapide",
    transactions: "Transactions",
    clients: "Clients",
    projects: "Projets",
    vendors: "Fournisseurs",
    income: "Revenu",
    expense: "Dépense",
    active: "Actif",
    completed: "Terminé",
    add_new_transaction: "Ajouter une Nouvelle Transaction",
    create_invoice: "Créer une Facture",
    add_client: "Ajouter un Client",
    add_project: "Ajouter un Projet",
    add_vendor: "Ajouter un Fournisseur",
    navigate_hint: "Naviguer",
    select_hint: "Sélectionner",
    close_hint: "Fermer"
  },
  it: {
    title: "Tavolozza Comandi",
    description: "Cerca pagine, transazioni, clienti, fornitori, report e azioni rapide",
    placeholder: "Cerca o vai a...",
    no_results: "Nessun risultato trovato",
    navigate: "Naviga",
    navigate_to: "Naviga verso",
    quick_actions: "Azioni Rapide",
    quick_action: "Azione rapida",
    transactions: "Transazioni",
    clients: "Clienti",
    projects: "Progetti",
    vendors: "Fornitori",
    income: "Entrata",
    expense: "Uscita",
    active: "Attivo",
    completed: "Completato",
    add_new_transaction: "Aggiungi Nuova Transazione",
    create_invoice: "Crea Fattura",
    add_client: "Aggiungi Cliente",
    add_project: "Aggiungi Progetto",
    add_vendor: "Aggiungi Fornitore",
    navigate_hint: "Naviga",
    select_hint: "Seleziona",
    close_hint: "Chiudi"
  },
  nl: {
    title: "Commandopalet",
    description: "Zoek pagina's, transacties, klanten, leveranciers, rapporten en snelle acties",
    placeholder: "Zoeken of spring naar...",
    no_results: "Geen resultaten gevonden",
    navigate: "Navigeren",
    navigate_to: "Navigeren naar",
    quick_actions: "Snelle Acties",
    quick_action: "Snelle actie",
    transactions: "Transacties",
    clients: "Klanten",
    projects: "Projecten",
    vendors: "Leveranciers",
    income: "Inkomsten",
    expense: "Uitgaven",
    active: "Actief",
    completed: "Voltooid",
    add_new_transaction: "Voeg Nieuwe Transactie Toe",
    create_invoice: "Maak Factuur",
    add_client: "Voeg Klant Toe",
    add_project: "Voeg Project Toe",
    add_vendor: "Voeg Leverancier Toe",
    navigate_hint: "Navigeren",
    select_hint: "Selecteren",
    close_hint: "Sluiten"
  },
  sv: {
    title: "Kommandopalett",
    description: "Sök sidor, transaktioner, klienter, leverantörer, rapporter och snabbåtgärder",
    placeholder: "Sök eller hoppa till...",
    no_results: "Inga resultat hittades",
    navigate: "Navigera",
    navigate_to: "Navigera till",
    quick_actions: "Snabbåtgärder",
    quick_action: "Snabbåtgärd",
    transactions: "Transaktioner",
    clients: "Klienter",
    projects: "Projekt",
    vendors: "Leverantörer",
    income: "Inkomst",
    expense: "Utgift",
    active: "Aktiv",
    completed: "Slutförd",
    add_new_transaction: "Lägg till Ny Transaktion",
    create_invoice: "Skapa Faktura",
    add_client: "Lägg till Klient",
    add_project: "Lägg till Projekt",
    add_vendor: "Lägg till Leverantör",
    navigate_hint: "Navigera",
    select_hint: "Välj",
    close_hint: "Stäng"
  },
  da: {
    title: "Kommandopalet",
    description: "Søg efter sider, transaktioner, klienter, leverandører, rapporter og hurtige handlinger",
    placeholder: "Søg eller hop til...",
    no_results: "Ingen resultater fundet",
    navigate: "Naviger",
    navigate_to: "Naviger til",
    quick_actions: "Hurtige Handlinger",
    quick_action: "Hurtig handling",
    transactions: "Transaktioner",
    clients: "Klienter",
    projects: "Projekter",
    vendors: "Leverandører",
    income: "Indkomst",
    expense: "Udgift",
    active: "Aktiv",
    completed: "Afsluttet",
    add_new_transaction: "Tilføj Ny Transaktion",
    create_invoice: "Opret Faktura",
    add_client: "Tilføj Klient",
    add_project: "Tilføj Projekt",
    add_vendor: "Tilføj Leverandør",
    navigate_hint: "Naviger",
    select_hint: "Vælg",
    close_hint: "Luk"
  },
  fi: {
    title: "Komentovalikko",
    description: "Hae sivuja, tapahtumia, asiakkaita, toimittajia, raportteja ja pikatoimintoja",
    placeholder: "Hae tai siirry...",
    no_results: "Ei tuloksia",
    navigate: "Navigoi",
    navigate_to: "Navigoi kohteeseen",
    quick_actions: "Pikatoiminnot",
    quick_action: "Pikatoiminto",
    transactions: "Tapahtumat",
    clients: "Asiakkaat",
    projects: "Projektit",
    vendors: "Toimittajat",
    income: "Tulo",
    expense: "Meno",
    active: "Aktiivinen",
    completed: "Valmis",
    add_new_transaction: "Lisää Uusi Tapahtuma",
    create_invoice: "Luo Lasku",
    add_client: "Lisää Asiakas",
    add_project: "Lisää Projekti",
    add_vendor: "Lisää Toimittaja",
    navigate_hint: "Navigoi",
    select_hint: "Valitse",
    close_hint: "Sulje"
  },
};
